import {FIELD_TYPE} from "types/enums";
import {ColumnsType} from "antd/es/table";
import {ColumnProps} from "types/models";
import {DataFormField} from "types/models/input-field-type";
import React from "react";
import {Button, Popconfirm, Row, Space} from "antd";
import {EyeSVG, PenSVG, RecycleSVG} from "assets";

const {INPUT, SELECT, DATE} = FIELD_TYPE;

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    show: true,
    render: (_v, _r, idx) => idx + 1,
    align: "center",
  },
  {title: "Mã CT", dataIndex: "maChuonTrinh", show: true, align: "left"},
  {title: "Tên CT", dataIndex: "tenChuongTrinh", show: true, align: "left"},
  {title: "Ngày tạo", dataIndex: "ngayTao", show: true, align: "left"},
  {title: "Người tạo", dataIndex: "nguoiTao", show: true, align: "left"},
  {title: "Người duyệt", dataIndex: "nguoiDuyet", show: true},
  {title: "Áp dụng từ", dataIndex: "apDungTu", show: true},
  {title: "Áp dụng đến", dataIndex: "apDungDen", show: true},
  {title: "Mô tả", dataIndex: "moTa", show: true},
  {title: "Trạng thái", dataIndex: "trangThai", show: true},
  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    align: "center",
    show: true,
    render: (value, record, idx) => {
      return (
        <Row justify={"center"}>
          <Space size={0}>
            <Popconfirm className="danger-confirm" title="Bạn muốn xóa?">
              <Button type="ghost" icon={<RecycleSVG />} size="small" />
            </Popconfirm>
            <Popconfirm className="danger-confirm" title="Bạn muốn chỉnh sửa?">
              <Button type="ghost" icon={<PenSVG />} size="small" />
            </Popconfirm>
            <Popconfirm className="danger-confirm" title="Bạn muốn xem?">
              <Button type="ghost" icon={<EyeSVG />} size="small" />
            </Popconfirm>
          </Space>
        </Row>
      );
    },
  },
];
const data = [
  {
    maChuongTrinh: "1238713",
    tenChuongTrinh: "CT X",
    ngayTao: "12/08/2022",
    nguoiTao: "Nguyen Van A",
    nguoiDuyet: "Nguyen Van B",
    apDungTu: "26/08/2023",
    apDungDen: "12/09/2023",
    moTa: "-",
    trangThai: "-",
  },
  {
    maChuongTrinh: "1238713",
    tenChuongTrinh: "CT X",
    ngayTao: "12/08/2022",
    nguoiTao: "Nguyen Van A",
    nguoiDuyet: "Nguyen Van B",
    apDungTu: "26/08/2023",
    apDungDen: "12/09/2023",
    moTa: "-",
    trangThai: "-",
  },
];

export {allColumns, data};
